import { render, staticRenderFns } from "./CrmBrowse.vue?vue&type=template&id=da7ed866"
import script from "./CrmBrowse.vue?vue&type=script&lang=ts"
export * from "./CrmBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da7ed866')) {
      api.createRecord('da7ed866', component.options)
    } else {
      api.reload('da7ed866', component.options)
    }
    module.hot.accept("./CrmBrowse.vue?vue&type=template&id=da7ed866", function () {
      api.rerender('da7ed866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/CrmBrowse.vue"
export default component.exports